import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  useMediaQuery
} from '@material-ui/core'
import { ModalTitleIconed } from 'asterX-UI/Modals/index'
import PropTypes from 'prop-types'
import React from 'react'

const ActionModal = ({
  open,
  onClose,
  color = 'primary',
  onCancel,
  onConfirm,
  title = '',
  labelCancel = 'Отмена',
  labelConfirm = 'Подтвердить',
  iconComponent = null,
  disableConfirm = false,
  subtitle = '',
  ...other
}) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('xs'))

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={isMobile ? 'xs' : 'sm'}
      fullWidth
      {...other}
    >
      <ModalTitleIconed
        onClose={onClose}
        iconComponent={iconComponent}
        subtitle={subtitle}
      >
        {title}
      </ModalTitleIconed>
      <DialogContent>{other.children}</DialogContent>
      {onConfirm && onCancel && (
        <DialogActions>
          <Grid
            container
            spacing={2}
            direction={'row'}
            justifyContent={'flex-start'}
          >
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <Button variant={'outlined'} fullWidth onClick={onCancel}>
                {labelCancel}
              </Button>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <Button
                variant={'contained'}
                color={color}
                fullWidth
                disabled={disableConfirm}
                onClick={onConfirm}
              >
                {labelConfirm}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      )}
    </Dialog>
  )
}
export default ActionModal
ActionModal.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  color: PropTypes.oneOf(['primary', 'secondary']),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  disableConfirm: PropTypes.bool,
  subtitle: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  labelCancel: PropTypes.string,
  labelConfirm: PropTypes.string,
  iconComponent: PropTypes.node
}
